// Lib
import React from 'react';
import classNames from 'classnames';

// Components
import ToolbarPopup from '../../../toolbar/toolbarPopup/ToolbarPopup';
import ToolbarItemsList from '../../toolbar/ToolbarItemsList';

// Types
import { MoreToolsSettings, ToolbarItemConfig } from '../../toolbarTypes';

// Styles
import './MoreToolPopup.scss';

const MorePopupContents = ({
    item,
    closePopup,
    ...rest
}: {
    item: ToolbarItemConfig;
    closePopup: () => void;
}): React.ReactElement => {
    React.useEffect(() => {
        return () => {
            closePopup();
        };
    }, []);

    const settings = item.toolSettings as MoreToolsSettings;

    return (
        <div
            className="MoreToolPopupContents"
            style={{ '--popup-columns': Math.ceil(settings.items.length / settings.groupSize) } as React.CSSProperties}
        >
            <ToolbarItemsList {...rest} items={settings.items} />
        </div>
    );
};

const MorePopup = (props: {
    item: ToolbarItemConfig;
    popupId: string;
    gridSizeName: string;
    className: string;
    closePopup: () => void;
}): React.ReactElement => {
    const settings = props.item.toolSettings as MoreToolsSettings;

    return (
        <ToolbarPopup
            ignoredClicksSelector={`#${settings.popupId}`}
            popupId={props.popupId}
            buttonSelector={`#${settings.popupId} .Icon.toolbar-more`}
            className={classNames('MoreToolPopup', `toolbar-size-${props.gridSizeName}`, props.className)}
            arrowColor="var(--ws-canvas-background)"
            closePopup={props.closePopup}
        >
            <MorePopupContents {...props} />
        </ToolbarPopup>
    );
};

export default MorePopup;
